import { Controller } from '@hotwired/stimulus';

// Contrôleur Stimulus pour nettoyer automatiquement les emails
// Supprime les espaces et convertit en minuscules en temps réel
export default class extends Controller {
  static targets = ['input'];

  connect() {
    // Nettoie l'email au chargement si le champ a déjà une valeur
    this.normalize();
  }

  // Nettoie l'email pendant la saisie (événement 'input')
  normalize() {
    const input = this.inputTarget;
    const cursorPosition = input.selectionStart;
    const originalValue = input.value;

    // Supprime les espaces et convertit en minuscules
    let cleaned = originalValue.trim().toLowerCase();

    // Met à jour la valeur uniquement si elle a changé
    if (input.value !== cleaned) {
      input.value = cleaned;

      // Ajuste la position du curseur
      const newCursorPosition = Math.min(cursorPosition, cleaned.length);
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }
  }

  // Nettoie l'email lors du collage (événement 'paste')
  paste(_event) {
    // Petite pause pour laisser le navigateur insérer le texte collé
    // puis on normalise
    setTimeout(() => this.normalize(), 0);
  }
}
